export default function SomeGapIco({ color }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_10176_15717)">
        <path
          d="M1 5.5C1 2.73858 3.23858 0.5 6 0.5H20C22.7614 0.5 25 2.73858 25 5.5V19.5C25 22.2614 22.7614 24.5 20 24.5H6C3.23858 24.5 1 22.2614 1 19.5V5.5Z"
          fill={color || "#FF4F6F"}
          shape-rendering="crispEdges"
        />
        <path
          d="M13.7984 8.67289L13.0022 13.4509L12.2061 8.67289C12.187 8.55736 12.1933 8.43905 12.2245 8.32619C12.2557 8.21333 12.3111 8.10861 12.3869 8.01931C12.4626 7.93001 12.5569 7.85827 12.6632 7.80907C12.7694 7.75986 12.8851 7.73438 13.0022 7.73438C13.1193 7.73438 13.235 7.75986 13.3413 7.80907C13.4476 7.85827 13.5418 7.93001 13.6176 8.01931C13.6933 8.10861 13.7487 8.21333 13.78 8.32619C13.8112 8.43905 13.8175 8.55736 13.7984 8.67289Z"
          stroke="white"
          stroke-width="1.4296"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.0026 17.5833C13.3535 17.5833 13.6379 17.2988 13.6379 16.9479C13.6379 16.597 13.3535 16.3125 13.0026 16.3125C12.6517 16.3125 12.3672 16.597 12.3672 16.9479C12.3672 17.2988 12.6517 17.5833 13.0026 17.5833Z"
          fill="white"
          stroke="white"
          stroke-width="1.4296"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_10176_15717"
          x="0"
          y="0"
          width="26"
          height="26"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10176_15717"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10176_15717"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
